const translation = {
  usePersonalInfo: "個人情報の収集および利用に関する同意",
  essential: "(必須)",

}

export { translation }